<ng-container *ngIf="currentUser">
  <h6
    data-cy="buyer-details__title"
    class="navigation__medium--l udex-mb-xs-12 udex-mb-20"
  >
    @if (isCurrentUserIndividual) {
      {{ 'checkout.digitalNativeCheckout.personalDetails' | cxTranslate }}
    } @else {
      {{ 'checkout.digitalNativeCheckout.buyerDetails' | cxTranslate }}
    }
  </h6>

  <div class="row">
    <div class="text-grey udex-mb-xs-6 udex-mb-0 col-sm-6">
      <span data-cy="buyer-details__name">{{ currentUser?.name }}</span>
      <br/>
      <span data-cy="buyer-details__email">{{ currentUser?.email }}</span>
    </div>
    <div *ngIf="!isCurrentUserIndividual && allowSelectTechnicalContact" class="col-sm-6">
      <ng-container *ngIf="contactsLoaded; else showSkeleton">
        <div data-cy="add-technical-contact">
          <div class="d-flex align-items-center">
            <udex-checkbox
              data-cy="add-technical-contact-checkbox"
              [text]=" 'checkout.digitalNativeCheckout.addTechnicalContact' | cxTranslate"
              [checked]="isTechnicalContactCheckboxChecked"
              (change)="onChange($event)"
              (keydown.enter)="onKeyDown($event)"
            ></udex-checkbox>
            <dcp-icon-button-tooltip
              data-cy="add-technical-contact-tooltip"
              [openOnClick]="true"
              accessibleName="addTechnicalContactTooltip"
            >
              <div class="body--s text-grey add-technical-contact-tooltip">
                {{ 'checkout.digitalNativeCheckout.addTechnicalContactTooltip' | cxTranslate }}
              </div>
            </dcp-icon-button-tooltip>
          </div>
          <div *ngIf="isTechnicalContactCheckboxChecked" class="udex-pt-20">
            <dcp-technical-contacts
              [header]="'checkout.digitalNativeCheckout.technicalContact' | cxTranslate"
              createNewContactText="checkout.digitalNativeCheckout.createNew.technicalContact"
              editContactText="checkout.digitalNativeCheckout.edit.technicalContact"
              contactType="checkout.digitalNativeCheckout.technicalContact"
              (selectedContact)="onContactSelect($event)"
              [newContactRole]="contactRole"
              [contacts]="contacts"
              [initialSelectedContact]="initialSelectedContact"
              [addExternalContacts]="true"
              [showEditButton]="true"></dcp-technical-contacts>
          </div>
        </div>
      </ng-container>
      <ng-template #showSkeleton>
        <div class="skeleton-height">
          <dcp-content-loading-indicator></dcp-content-loading-indicator>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
